import { i18nKeys } from 'translationTypes'
import i18n from '../../../../i18n'

export default {
  titleText: () => i18n.t(i18nKeys.deliveryIssueDispute_title),
  titleDescriptionText: () =>
    i18n.t(i18nKeys.deliveryIssueDispute_title_description),
  textFieldLabelText: () =>
    i18n.t(i18nKeys.deliveryIssueDispute_textfield_label),
  textFieldDescriptionText: () =>
    i18n.t(i18nKeys.deliveryIssueDispute_textfield_description),
  textFieldPlaceholderText: () =>
    i18n.t(i18nKeys.deliveryIssueDispute_textfield_placeholder),
  remainingCharactersText: text =>
    i18n.t(i18nKeys.deliveryIssueDispute_remaining_character, { text }),
  buttonSubmitText: () => i18n.t(i18nKeys.deliveryIssueDispute_submit),
  alertTitleText: () => i18n.t(i18nKeys.deliveryIssueDisputeError_title),
  alertSubtitleText: () => i18n.t(i18nKeys.deliveryIssueDisputeError_subTitle),
  alertDismissText: () => i18n.t(i18nKeys.deliveryIssueDisputeError_dimissText),
}
